import axios from 'axios';
import { AppConfig } from '../config';
let userAuthToken = '';
let userRefreshToken = '';

export const api = axios.create({
  baseURL: AppConfig.apiBaseUrl
});

export const setUserAuthToken = (token) => {
  userAuthToken = token;
};

export const setUserRefreshToken = (token) => {
  userRefreshToken = token;
};

// Fetching from localstorage
const getAuthToken = async () => {
  const sessionData = await JSON.parse(
    window.sessionStorage.getItem('authorization')
  );

  return sessionData?.token ?? '';
};

api.interceptors.request.use(
  async (config) => {
    const { needsToken } = config.headers;

    if (needsToken) {
      if (!userAuthToken) {
        userAuthToken = await getAuthToken();
      }

      if (userAuthToken) {
        config.headers['Authorization'] = 'Token ' + userAuthToken;
      }

      if (userRefreshToken) {
        config.headers['Refresh-Authorization'] = userRefreshToken;
      }
    }

    // REMOVE ME
    config.headers['ngrok-skip-browser-warning'] = '69420';

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    if (
      response?.headers['refresh-authorization'] &&
      response?.headers['refresh-authorization'] !== 'none'
    ) {
      // Updating the token for the next request
      setUserAuthToken(response.headers['refresh-authorization']);

      // Updating the token in session storage
      const previousResp = JSON.parse(
        window.sessionStorage.getItem('authorization')
      );

      window.sessionStorage.setItem(
        'authorization',

        JSON.stringify({
          ...previousResp,
          token: response.headers['refresh-authorization']
        })
      );
    }
    return response;
  },
  async (error) => {
    if (
      error?.response?.status === 401 &&
      error?.response?.data?.error === 'Session expired'
    ) {
      const authenticationError = new CustomEvent('authError', {
        detail: error
      });
      window.dispatchEvent(authenticationError);
    }
    return Promise.reject(error);
  }
);

export * from './modules/bulkOrder';
export * from './modules/common';
export * from './modules/communications';
export * from './modules/core';
export * from './modules/dashboard';
export * from './modules/order';
export * from './modules/partner';
export * from './modules/project';
export * from './modules/recordingJurisdiction';
export * from './modules/signature';
export * from './modules/siteMap';
export * from './modules/rateCalculator';
export * from './modules/clientDashboard';
export * from './modules/clientNotifications';
export * from './modules/userPreferences';
export * from './modules/demo';
